import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { AppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { HelmetProvider } from 'react-helmet-async';

import { PaywallProvider } from '@/hooks/usePaywall';
import { UserProvider } from '@/state/UserContext';
import { MobileNavigationProvider } from '@/state/MobileNavigationContext';
import { reactPlugin } from '@/lib/appInsights';
import ClientSideNavigation from './utils/clientSideNavigation';
import AppRoutes from './routes/AppRoutes';
import { useMsalEvents } from './hooks/useMsalEvents';

type AppProps = {
  pca: PublicClientApplication;
};

function Routes() {
  useMsalEvents();
  return <AppRoutes />;
}

function App({ pca }: AppProps) {
  return (
    <HelmetProvider>
      <ClientSideNavigation pca={pca}>
        <MsalProvider instance={pca}>
          <UserProvider>
            <MobileNavigationProvider navigationElementId='header-navigation'>
              <AppInsightsContext.Provider value={reactPlugin}>
                <PaywallProvider>
                  <Routes />
                </PaywallProvider>
              </AppInsightsContext.Provider>
            </MobileNavigationProvider>
          </UserProvider>
        </MsalProvider>
      </ClientSideNavigation>
    </HelmetProvider>
  );
}

export default App;
